import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Rolepermissions*/
export const registerRolepermission = async (rolepermissionData) => {
  try {
    const response = await api.post("/role-permissions", rolepermissionData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchRolepermissionsFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}) => {
  try {
    const params = {
      page,
      per_page: perPage
    };

    if (search) {
      params.search = search;
    }

    if (columnFilters.role_id) {
      params.role_id = columnFilters.role_id;
    }

    if (columnFilters.menu_id) {
      params.menu_id = columnFilters.menu_id;
    }

    const response = await api.get("/role-permissions", { params });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteRolepermissionsFromAPI = async (rolepermissionId) => {
  try {
    const response = await api.delete(`/role-permissions/${rolepermissionId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchRolepermissionsById = async (rolepermissionId) => {
  try {
    const response = await api.get(`/role-permissions/${rolepermissionId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data rolepermission", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateRolepermission = async (id, rolepermissionData) => {
  try {
    const response = await api.put(`/role-permissions/${id}`, rolepermissionData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchPermissionsByRole = async (roleId) => {
  try {
    const response = await api.get(`/role-permissions/role/${roleId}`);
    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get permissions by role", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchPermissionsByMenu = async (menuId) => {
  try {
    const response = await api.get(`/role-permissions/menu/${menuId}`);
    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get permissions by menu", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const bulkUpdateRolePermissions = async (roleId, permissions) => {
  try {
    const response = await api.put("/role-permissions/bulk", {
      role_id: roleId,
      permissions: permissions
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("bulk update", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* ========== NEW METHODS FOR DXHUB CONCEPT ========== */

/**
 * Get menus assigned to a role (from tb_m_role_menus)
 */
export const getMenusByRole = async (roleId) => {
  try {
    const response = await api.get(`/role-permissions/role/${roleId}/menus`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get menus by role", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/**
 * Sync menus to a role (replace all existing menus)
 */
export const syncMenusToRole = async (roleId, menuIds) => {
  try {
    const response = await api.put(`/role-permissions/role/${roleId}/menus`, {
      menu_ids: menuIds
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("sync menus to role", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/**
 * Get permissions assigned to a role (from tb_m_role_permissions_new)
 */
export const getPermissionsByRoleNew = async (roleId) => {
  try {
    const response = await api.get(`/role-permissions/role/${roleId}/permissions`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get permissions by role", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/**
 * Sync permissions to a role (replace all existing permissions)
 */
export const syncPermissionsToRole = async (roleId, permissionIds) => {
  try {
    const response = await api.put(`/role-permissions/role/${roleId}/permissions`, {
      permission_ids: permissionIds
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("sync permissions to role", "rolepermission");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

